import { axiosAjax } from '@app/src/config/axios';
import { hydrateData, hydrateDataPost, hydrateDataPut } from './hydrators';
import { TypeProfileModel } from '@app/src/views/StepPayment/formPayment/models/TypeProfileModel';
import { isClientEnv } from '@app/src/utils/validations';

export const dniService = {
  async get(documentNumber: string): Promise<TypeProfileModel> {
    const userStorage = isClientEnv() && JSON.parse(localStorage.getItem('user'));
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With':'XMLHttpRequest',
          'Authorization': `Bearer ${userStorage && userStorage.jwt}`
        }
      }

      const { data } = await axiosAjax.get(
        process.env.API_TYPE_PROFILE
        .replace(':documentNumber', '' + documentNumber),
        config
        );
      if (data.error) {
        throw new Error();
      }
      return data.data && data.data.length > 0 ? hydrateData(data.data[0]) : {};
    } catch (e) {
      throw new Error(e);
    }
  },
  async post(json: TypeProfileModel): Promise<TypeProfileModel> {
    const userStorage = isClientEnv() && JSON.parse(localStorage.getItem('user'));
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With':'XMLHttpRequest',
          'Authorization': `Bearer ${userStorage && userStorage.jwt}`
        }
      }

      const { data } = await axiosAjax.post(
        process.env.API_TYPE_PROFILE.replace('/:documentNumber', ''),
        hydrateDataPost(json),
        config
      );
      if (data.error) {
        throw new Error();
      }
      return data.data && data.data.length > 0 ? hydrateData(data.data[0]) : {};
    } catch (e) {
      throw new Error(e);
    }
  },
  async put(json: TypeProfileModel, documentNumber: string): Promise<TypeProfileModel> {
    const userStorage = isClientEnv() && JSON.parse(localStorage.getItem('user'));
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With':'XMLHttpRequest',
          'Authorization': `Bearer ${userStorage && userStorage.jwt}`
        }
      }

      const { data } = await axiosAjax.put(
        process.env.API_TYPE_PROFILE
        .replace(':documentNumber', '' + documentNumber),
        hydrateDataPut(json),
        config
      );
      if (data.error) {
        throw new Error();
      }
      return data.data && data.data.length > 0 ? hydrateData(data.data[0]) : {};
    } catch (e) {
      throw new Error(e);
    }
  }
}

